import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  container: {
    display: 'flex',
    maxWidth: '100%',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
}));
